export default __webpack_public_path__ + "static/media/zoll.d7459cf8.png";